import React from "react";

import { string, shape, number, arrayOf, func, bool } from "prop-types";

import { SelectListGroup } from "../common";

import { nonChangableTeamCodes } from "../helpers/helpers";
import { mapToMainBranch } from "../helpers/nearestBranch";

const mapBranchToSelect = ({ name, code }) => ({ label: name, value: code });

const selectAlphabeticalAscComp = (a, b) => (a.label > b.label ? 1 : -1);

const getBranchOptions = (branches) => {
  const options = branches
    .filter(({ code }) => code !== "")
    .map(mapBranchToSelect)
    .sort(selectAlphabeticalAscComp);

  return [{ label: "Select a branch", value: "" }, ...options];
};

const SelectBranch = ({
  responsibleTeamCode,
  branches,
  onChange,
  classes = "",
}) => (
  <div className="form-group">
    <label>Local HRGO branch *</label>
    <SelectListGroup
      value={mapToMainBranch(responsibleTeamCode)}
      onChange={(e) => onChange("responsibleTeam", e.target.value)}
      classes={`register_field register_field-dropdown ${classes}`}
      options={getBranchOptions(branches)}
      isDisabled={nonChangableTeamCodes.includes(
        mapToMainBranch(responsibleTeamCode)
      )}
    />
  </div>
);

export const branchPropTypes = {
  name: string.isRequired,
  code: string.isRequired,
  lat: number.isRequired,
  long: number.isRequired,
};

SelectBranch.propTypes = {
  responsibleTeamCode: string.isRequired,
  branches: arrayOf(shape(branchPropTypes)).isRequired,
  onChange: func.isRequired,
  classes: string,
};

export default SelectBranch;
